import { RawRuleOf } from "@casl/ability";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import usersService from "../services/users.service";
import abilityBuild, { AppAbility } from "../shared/CASL/appAbility";
import { RoleContext } from "../shared/enums";
import { IFeature, IRuolo, IUser } from "../shared/interfaces";


const queryString = require('query-string');


interface CheckRolesProps {
    currentUser: IUser | undefined,
    allRoles: IRuolo[] | undefined,
    features: IFeature[] | undefined
}

type Props = CheckRolesProps & RouteComponentProps

export const checkRoles = <P extends object>(WrappedComponent: React.ComponentType<P>, componentRoleContext: RoleContext) =>
    class CheckRoles extends React.Component<P & Props> {

        componentDidMount() {
            this.updateAbility();

        }
        componentDidUpdate(prevProps: Props) {

            if (prevProps.currentUser !== this.props.currentUser ||
                prevProps.allRoles !== this.props.allRoles ||
                prevProps.features !== this.props.features ||
                prevProps.location !== this.props.location
            ) {
                this.updateAbility();
            }


        }

        private updateAbility() {
            if (this.props.currentUser && this.props.currentUser.ruoliUorContext &&
                this.props.allRoles && this.props.features) {


                let aooId = Number(this.props.match.params["aooId"]);

                let rawRules: RawRuleOf<AppAbility>[] = [];
                const { location } = this.props;
                const parsedQueryString = queryString.parse(location.search);
                let uorId: number = 0;
                if (parsedQueryString.uorId) {
                    uorId = Number(parsedQueryString.uorId);
                }

                let allUserRoles: IRuolo[] = [];
                this.props.currentUser.ruoliUorContext.forEach(el => {
                    if (el.uorId === uorId && el.ruolo)
                        allUserRoles.push(el.ruolo);
                });

                this.props.currentUser.ruoliAooContext.forEach(el => {
                    if (el.aooId === aooId && el.ruolo)
                        allUserRoles.push(el.ruolo);
                });

                // Ottengo le abilità in base al ruolo dell'utente
                let rulesFromUserRoles = this.getRulesFromUserRoles(allUserRoles, uorId);
                // Ottento le abilità in base alle features attive
                let rulesFromFeatures = this.getRulesFromFeatures(allUserRoles);

                rawRules = rulesFromUserRoles.concat(rulesFromFeatures);
                // se rulesFromUserRoles è vuoto significa che l'utente non ha un ruolo e quindi non può accedere a nulla
                abilityBuild.update(rawRules);
            }

        }

        private getRulesFromUserRoles(allUserRoles: IRuolo[], uorId: number) {
            let rawRules: RawRuleOf<AppAbility>[] = [];


            /// verifico se l'utente ha un ruolo relativo al contesto 
            /// del component corrente (il contesto può essere UOR o AOO)
            let contextRolePartial = allUserRoles.find(el => el.context === componentRoleContext);
            let contextRole = this.props.allRoles?.find(el => el.id === contextRolePartial?.id);


            /// verifico se l'utente è Supervisore o Admin
            let aooId = Number(this.props.match.params["aooId"]);
            let isSupervisor = usersService.userIsSupervisore(this.props.currentUser!, aooId);
            let supervisorRole = this.props.allRoles?.find(el => el.nome === "Supervisore");

            let isAdmin = usersService.userIsAdmin(this.props.currentUser!, aooId);;
            let adminRole = this.props.allRoles?.find(el => el.nome === "Admin");

            let superAdminRole = this.props.allRoles?.find(el => el.nome === "SuperAdmin");

            let uorRolePartial = allUserRoles.find(el => el.context === RoleContext.Uor);
            let uorRole = this.props.allRoles?.find(el => el.id === uorRolePartial?.id);

            /// se l'utente ha un ruolo relativo al contesto del component corrente
            if (contextRole) {
                switch (componentRoleContext) {
                    case RoleContext.Uor:
                        if (uorId > 0) {
                            /// Come contesto UOR l'utente può essere Operatore o Ordinario
                            rawRules = this.rawRulesForUor(contextRole.permissions, uorId);
                        }
                        break;
                    case RoleContext.Aoo:

                        /// Come contesto AOO l'utente può essere sia Admin che Supervisore
                        rawRules = contextRole.permissions;
                        if (this.props.currentUser!.isSuperAdmin && superAdminRole) {
                            rawRules = this.remapRulesForSuperAdmin(superAdminRole, rawRules);
                        }

                        break;
                }

            }
            /// se l'utente non ha un ruolo relativo al contesto 
            /// (ad esempio un Supervisore che accede ad un protocollo oppure un Operatore che accede all'organigramma)
            else if (isAdmin && adminRole) {
                rawRules = adminRole.permissions;
                /// Qua devo aggiornare i permessi con l'aooid
                if (this.props.currentUser!.isSuperAdmin && superAdminRole) {
                    rawRules = superAdminRole.permissions;
                }

            }
            else if (isSupervisor && supervisorRole) {
                rawRules = supervisorRole.permissions;
                if (this.props.currentUser!.isSuperAdmin && superAdminRole) {
                    rawRules = this.remapRulesForSuperAdmin(superAdminRole, rawRules);
                }

            }
            else if (this.props.currentUser!.isSuperAdmin && superAdminRole) {
                rawRules = superAdminRole.permissions;
            }

            else if (uorRole) {
                rawRules = this.rawRulesForUor(uorRole.permissions, uorId);
            }
            return rawRules;
        }

        private remapRulesForSuperAdmin(superAdminRole, rawRules: RawRuleOf<AppAbility>[]): RawRuleOf<AppAbility>[]{
            let newRawRules: RawRuleOf<AppAbility>[] = [...rawRules];
            var superAdminPermissions = [...superAdminRole.permissions];
            superAdminPermissions.forEach((rule, index) => {
                if (rule.action.toString() === 'manage') {
                    /// rimuovo i permessi che per l'utente superadmin hanno action 'manage'
                    newRawRules = newRawRules.filter(el => el.subject !== rule.subject);
                }

                newRawRules.push(rule);
            });
            return newRawRules;

        }
        private getRulesFromFeatures(allUserRoles: IRuolo[]) {
            let rawRules: RawRuleOf<AppAbility>[] = [];

            if (allUserRoles && this.props.features) {
                let { features } = this.props;

                let enabledFeatureKeys: string[] = features!.filter(el => el.enabled).reduce((a: string[], o) => (o.key && a.push(o.key), a), [])


                if (enabledFeatureKeys && enabledFeatureKeys.length > 0) {
                    rawRules.push({
                        action: "use",
                        subject: "IFeature",
                        conditions: {
                            "key": {
                                "$in": enabledFeatureKeys
                            }
                        }
                    });
                };
            }
            return rawRules;
        }

        rawRulesForUor = (permissions, uorId: number) => {
            let rawRules: RawRuleOf<AppAbility>[] = permissions;

            rawRules.forEach((rule, index) => {

                if (rule.subject === "IProtocol") {
                    let protocolRule: any = { ...rule };
                    protocolRule.conditions.visibilita.$elemMatch['uor.id'] = uorId;

                    rawRules[index] = protocolRule;
                }
                else if (rule.subject === "IFascicolo") {
                    let protocolRule: any = { ...rule };
                    protocolRule.conditions.uorId = uorId;

                    rawRules[index] = protocolRule;
                }
            });

            return rawRules;
        }
        render() {
            return <WrappedComponent {...this.props} />;
        }
    };